import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Stack,
  Switch,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import AddIcon from "@mui/icons-material/Add";
import Loader from "../../../components/loader/Loader";
import { useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import { yupResolver } from "@hookform/resolvers/yup";
import { grey, orange, red } from "@mui/material/colors";
import { FormInputText } from "../../../components/form-components/FormInputText";
import SaveIcon from "@mui/icons-material/Save";
import { addonSchema } from "../../../app/schema";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { FormInputDropdown } from "../../../components/form-components/FormInputDropdown";
import {
  hideConfirmModal,
  showConfirmModal,
  showModal,
  storeAddonsList,
} from "../../../redux/counterSlice";
import GeneralImageUpload from "../../../components/form-components/GeneralImageUpload";
import { FormAutoComplete } from "../../../components/form-components/FormAutoComplete";
import { parseArray } from "../../../app/utlils";
import {
  useTablePagination,
  useTableHeight,
} from "../../../hooks/useTablePagination";
import { usePermission } from "../../../hooks/usePermission";
import { Controller } from "react-hook-form";
import StreamEngineIcon from "../../../assets/steam-engine.png";
import { Tooltip } from "@mui/material";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";

// Import your custom hook

function Addons() {
  const dispatch = useDispatch();
  const { addonsList, regionList, taxList } = useSelector(
    (state) => state.counter,
  );
  const permissions = usePermission("Addons");
  // Use custom hook for pagination and search state/handlers
  const {
    page,
    rowsPerPage,
    searchText,
    onChangePage,
    onChangeRowsPerPage,
    onSearchChange,
  } = useTablePagination("addons", 10);
  const tableHeight = useTableHeight();
  const hasActionPermission = permissions?.edit || permissions?.delete;

  const methods = useForm({
    resolver: yupResolver(addonSchema),
  });
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = methods;

  const [loader, setLoader] = useState(true);
  const [open, setOpen] = useState(false);
  const [openImage, setOpenImage] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [formData, setFormData] = useState([]);

  const loadInitialData = () => {
    setLoader(true);
    axios
      .get("/indexAddons")
      .then(function (response) {
        dispatch(storeAddonsList(response?.data?.data));
      })
      .catch(function (err) {
        toast.error(err?.message);
      })
      .finally(() => {
        setLoader(false);
        dispatch(hideConfirmModal({ msg: "" }));
      });
  };
  useEffect(() => {
    if (searchText === "," || searchText === null || searchText === undefined) {
      onSearchChange("");
    }
  }, []);
  useEffect(() => {
    loadInitialData();
  }, []);

  // Sync Redux addonsList to local formData
  useEffect(() => {
    if (addonsList?.length) {
      setFormData(addonsList);
    }
  }, [addonsList]);

  // Columns definition remains same
  const columns = [
    {
      name: "addon_id",
      label: "S. No",
      options: {
        customBodyRenderLite: (dataIndex) => {
          return <p>{+dataIndex + 1}</p>;
        },
      },
    },
    {
      name: "image",
      label: "Image",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const imageUrl = formData[dataIndex]?.image;
          return imageUrl ? (
            <PhotoProvider>
              <PhotoView key={dataIndex} src={imageUrl}>
                <img
                  src={imageUrl}
                  alt=""
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                />
              </PhotoView>
            </PhotoProvider>
          ) : (
            <h3>-</h3>
          );
        },
      },
    },
    {
      name: "product_name",
      label: "Addon Name",
    },
    {
      name: "stream_engine",
      label: "Addon Type",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const val = formData[dataIndex]?.stream_engine;

          return val === 1 ? (
            <Tooltip title="Steam Engine Addon">
              <img
                src={StreamEngineIcon}
                alt="Steam Engine"
                style={{ width: 20, height: 20, cursor: "pointer" }}
              />
            </Tooltip>
          ) : (
            <Tooltip title="Normal Addon">
              <CakeOutlinedIcon
                sx={{ color: "gray", cursor: "pointer" }}
                fontSize="small"
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: "regions",
      label: "Region",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const regions = formData[dataIndex]?.regions;

          if (!regions || regions.length === 0) return "-";

          return regions
            .map((r) => r?.city?.name)
            .filter(Boolean)
            .join(", ");
        },
      },
    },
    {
      name: "active_status",
      label: "Status",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const status = formData[dataIndex]?.active_status;
          const image = formData[dataIndex]?.image;

          return (
            <Switch
              size="small"
              disabled={!image}
              color={status === 1 ? "success" : "error"}
              checked={status === 1}
              onChange={() => {
                dispatch(
                  showConfirmModal({
                    msg: status === 1 ? "Deactivate" : "Activate",
                    action: () =>
                      toggleStatus(formData[dataIndex]?.addon_id, image),
                  }),
                );
              }}
              style={{ marginBottom: "5px" }}
            />
          );
        },
      },
    },
    ...(hasActionPermission
      ? [
          {
            name: "Actions",
            options: {
              customBodyRenderLite: (dataIndex) => {
                const status = formData[dataIndex]?.active_status;
                const image = formData[dataIndex]?.image;
                return (
                  <div className="actionBtns">
                    <Button
                      disabled={status === 1}
                      aria-label="edit"
                      onClick={() => {
                        setSelectedRow(() => ({ ...formData[dataIndex] }));
                        setOpenImage(true);
                      }}
                    >
                      <AddPhotoAlternateIcon
                        sx={{
                          color: status === 1 ? grey[600] : orange[500],
                        }}
                        fontSize="medium"
                      />
                    </Button>
                    {permissions?.edit && (
                      <Button
                        disabled={status === 1}
                        aria-label="edit"
                        onClick={() => editClickHandler(formData[dataIndex])}
                      >
                        <EditIcon
                          fontSize="medium"
                          sx={{ color: status === 1 ? grey[600] : "secondary" }}
                        />
                      </Button>
                    )}
                  </div>
                );
              },
            },
          },
        ]
      : []),
  ];

  const handleClose = () => {
    setOpen(false);
    setOpenImage(false);
    setSelectedRow(null);
    reset();
  };

  const editClickHandler = (item) => {
    setSelectedRow({ ...item });
    reset({
      region_id: item?.regions?.map((r) => ({
        value: r?.region_id,
        label: r?.city?.name,
      })),
      product_name: item?.product_name,
      price: item?.price,
      hsn: item?.hsn,
      tax_id: item?.tax_id,
      stream_engine: item?.stream_engine ?? 0,
    });
    setOpen(true);
  };

  const onSubmit = (data) => {
    const payload = {
      ...data,
      region_id: parseArray(data.region_id),
      stream_engine: data.stream_engine ? 1 : 0,
    };
    saveForm(payload);
  };

  const toggleStatus = (id, image) => {
    setLoader(true);
    axios
      .get("/addonsSwitch/" + id)
      .then(function () {
        loadInitialData();
      })
      .catch(function (err) {
        toast.error(err?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const saveForm = async (data) => {
    setLoader(true);
    try {
      let response;
      if (selectedRow?.addon_id) {
        response = await axios.post(
          "/updateAddons",
          { ...data, addon_id: selectedRow?.addon_id },
          data,
        );
      } else {
        response = await axios.post("/createAddons", data);
      }

      if (!response?.data?.error) {
        toast.success(response?.data?.message);
        loadInitialData();
        setOpen(false);
        setSelectedRow(() => null);
        reset();
      } else {
        let errDesc = "";
        if (response?.data?.data) {
          Object.values(response?.data?.data).map((error, index) => {
            errDesc =
              index === 0 ? errDesc + error + "\n " : errDesc + error + "\n ";
          });
        } else {
          errDesc = response?.data?.message;
        }

        dispatch(
          showModal({
            msg: errDesc,
            error: response?.data?.error,
          }),
        );
      }
    } catch (error) {
      dispatch(
        showModal({
          msg: error?.message,
          error: true,
        }),
      );
    } finally {
      setLoader(false);
    }
  };

  const CreateEditDialog = React.memo(() => (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{ color: "primary.main", fontWeight: 600, fontSize: "1.25rem" }}
      >
        {selectedRow ? "Edit Addon" : "New Addon"}
      </DialogTitle>
      <DialogContent sx={{ pb: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormAutoComplete
              name="region_id"
              control={control}
              label="Region"
              multiple={true}
              dataArray={regionList?.map((item) => ({
                value: item?.region_id,
                label: item?.city?.name,
              }))}
              errors={errors}
              defaultValue={selectedRow?.regions?.map((item) => ({
                value: item?.region_id,
                label: item?.city?.name,
              }))}
              mandatory="true"
            />
          </Grid>
          <Grid item xs={12}>
            <FormInputText
              name="product_name"
              control={control}
              label="Addon Name"
              errors={errors}
              mandatory="true"
              defaultValue={selectedRow?.product_name}
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputText
              name="price"
              control={control}
              label="Price"
              errors={errors}
              mandatory="true"
              defaultValue={selectedRow?.price}
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputText
              name="hsn"
              control={control}
              label="HSN Code"
              errors={errors}
              mandatory="true"
              defaultValue={selectedRow?.hsn}
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputDropdown
              name="tax_id"
              control={control}
              label="Tax"
              type="single"
              options={taxList?.map((tax) => ({
                id: tax.tax_id,
                name: `${tax.tax_percentage} %`,
              }))}
              errors={errors}
              defaultValue={selectedRow?.tax_id}
              mandatory="true"
            />
          </Grid>

          <Grid item xs={6}>
            <Stack direction="row" alignItems="center" spacing={1} mt={2.5}>
              <Controller
                name="stream_engine"
                control={control}
                defaultValue={selectedRow?.stream_engine ?? 0}
                render={({ field }) => (
                  <Switch
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                  />
                )}
              />
              <span>Steam Engine Addon</span>
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          color="error"
          sx={{ borderRadius: 2, px: 3 }}
        >
          CANCEL
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
          sx={{ borderRadius: 2, px: 3 }}
        >
          SAVE
        </Button>
      </DialogActions>
    </Dialog>
  ));

  const UpdateImageDialog = () => (
    <Dialog open={openImage} onClose={handleClose} maxWidth={"xs"}>
      <DialogTitle className="text-primary">Update Image</DialogTitle>
      <Divider variant="middle" className="bg-primary" />
      <DialogContent>
        <Grid container columnSpacing={{ xs: 4 }}>
          <Grid item xs={12}>
            <GeneralImageUpload
              status={selectedRow?.image}
              name={selectedRow?.addon_id?.toString()}
              control={control}
              label={selectedRow?.product_name}
              setValue={setValue}
              type="text"
              defaultValue={selectedRow?.image}
              loadInitialData={loadInitialData}
              url="imageUpdateAddons"
              formDataKey={{ id: "id", image: "addon_image" }}
              dimension="Aspect Ratio 1:1"
              setOpenImage={setOpenImage}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="error">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );

  const options = {
    enableNestedDataAccess: ".",
    selectableRows: false,
    filter: false,
    download: false,
    viewColumns: true,
    print: false,
    searchText: searchText,
    fixedHeader: true,
    tableBodyHeight: tableHeight,
    onSearchChange: (searchValue) => onSearchChange(searchValue),
    onSearchClose: () => onSearchChange(""),
    rowsPerPage: rowsPerPage,
    page: page,
    onChangeRowsPerPage: (numberOfRows) => onChangeRowsPerPage(numberOfRows),
    onChangePage: (currentPage) => onChangePage(currentPage),
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <h4 className="text-dark">Addons</h4>

          <MUIDataTable
            data={formData?.length > 0 ? formData : []}
            columns={columns}
            options={options}
            title={
              permissions.add ? (
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    setSelectedRow(null);
                    setOpen(true);
                    reset();
                  }}
                  startIcon={<AddIcon />}
                >
                  New Addon
                </Button>
              ) : null
            }
          />
        </>
      )}
      <CreateEditDialog />
      <UpdateImageDialog />
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {selectedRow?.confirmLabel} ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmOpen(false)}
            variant="contained"
            color="error"
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={() => selectedRow?.action()}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Addons;
